import React from "react";

import talentLenzRankedShortlistDashboard from "../../images/talentlenz-ranked-shortlist-dashboard.svg";
import talentLenzRankedShortlistHrReviewPhoto from "../../images/talentlenz-ranked-shortlist-hr-review-photo.jpg";
import talentLenzRankedShortlistWallSign from "../../images/talentlenz-ranked-shortlist-wall-sign.svg";

import "./TalentLenzRankedShortlist.css";

export default function TalentLenzRankedShortlist() {
  return (
    <section
      id="talentlenz-match"
      className="talentlenz-ranked-shortlist"
      aria-labelledby="talentlenz-ranked-shortlist-title"
    >
      <div className="talentlenz-ranked-shortlist__inner">
        <div className="talentlenz-ranked-shortlist__copy">
          <p className="talentlenz-ranked-shortlist__eyebrow">
            RANK WITH CLARITY
          </p>

          <h2
            id="talentlenz-ranked-shortlist-title"
            className="talentlenz-ranked-shortlist__title"
          >
            <span className="talentlenz-ranked-shortlist__screen-reader-only">
              Turn application volume into a shortlist your team can
              explain.
            </span>

            <span
              className="talentlenz-ranked-shortlist__title-layout talentlenz-ranked-shortlist__title-layout--wide"
              aria-hidden="true"
            >
              Turn application
              <br />
              volume into a
              <br />
              shortlist your team
              <br />
              can explain.
            </span>

            <span
              className="talentlenz-ranked-shortlist__title-layout talentlenz-ranked-shortlist__title-layout--portrait"
              aria-hidden="true"
            >
              Turn application volume
              <br />
              into a shortlist your team
              <br />
              can explain.
            </span>

            <span
              className="talentlenz-ranked-shortlist__title-layout talentlenz-ranked-shortlist__title-layout--mobile"
              aria-hidden="true"
            >
              Turn application
              <br />
              volume into
              <br />
              a shortlist
              <br />
              your team can
              <br />
              explain.
            </span>
          </h2>

          <p className="talentlenz-ranked-shortlist__description">
            <span className="talentlenz-ranked-shortlist__screen-reader-only">
              Analyse applicants individually or in bulk. TalentLenz
              compares the evidence consistently, ranks suitability for
              that opportunity and gives HR a clear view of who should
              move forward.
            </span>

            <span
              className="talentlenz-ranked-shortlist__description-layout talentlenz-ranked-shortlist__description-layout--desktop"
              aria-hidden="true"
            >
              Analyse applicants individually or in bulk.
              <br />
              TalentLenz compares the evidence consistently,
              <br />
              ranks suitability for that opportunity and gives
              <br />
              HR a clear view of who should move forward.
            </span>

            <span
              className="talentlenz-ranked-shortlist__description-layout talentlenz-ranked-shortlist__description-layout--landscape"
              aria-hidden="true"
            >
              Analyse applicants individually or in bulk.
              <br />
              TalentLenz compares evidence consistently
              <br />
              and gives HR a clear view of who should
              <br />
              move forward.
            </span>

            <span
              className="talentlenz-ranked-shortlist__description-layout talentlenz-ranked-shortlist__description-layout--portrait"
              aria-hidden="true"
            >
              Analyse applicants individually or in bulk. TalentLenz compares
              <br />
              evidence consistently and gives HR a clear view of who should
              <br />
              move forward.
            </span>

            <span
              className="talentlenz-ranked-shortlist__description-layout talentlenz-ranked-shortlist__description-layout--mobile"
              aria-hidden="true"
            >
              Analyse individually or in bulk. TalentLenz
              <br />
              compares evidence consistently and gives HR
              <br />
              a clear view of who should move forward.
            </span>
          </p>
        </div>

        <div
          className="talentlenz-ranked-shortlist__visual"
          role="img"
          aria-label="An HR team reviewing applicants with a TalentLenz ranked shortlist interface overlaid."
        >
          <img
            className="talentlenz-ranked-shortlist__photo"
            src={talentLenzRankedShortlistHrReviewPhoto}
            alt=""
            aria-hidden="true"
            draggable={false}
          />

          <div
            className="talentlenz-ranked-shortlist__dashboard-backdrop"
            aria-hidden="true"
          />

          <img
            className="talentlenz-ranked-shortlist__dashboard"
            src={talentLenzRankedShortlistDashboard}
            alt=""
            aria-hidden="true"
            draggable={false}
          />

          <img
            className="talentlenz-ranked-shortlist__wall-sign"
            src={talentLenzRankedShortlistWallSign}
            alt=""
            aria-hidden="true"
            draggable={false}
          />
        </div>

        <div className="talentlenz-ranked-shortlist__decision-support">
          <span className="talentlenz-ranked-shortlist__decision-support-label">
            DECISION SUPPORT
          </span>

          <p className="talentlenz-ranked-shortlist__decision-support-copy">
            Ranked. Compared. Still human-decided.
          </p>
        </div>
      </div>
    </section>
  );
}